import { render, staticRenderFns } from "./TestPrice.vue?vue&type=template&id=64a0a626&scoped=true&"
import script from "./TestPrice.vue?vue&type=script&lang=js&"
export * from "./TestPrice.vue?vue&type=script&lang=js&"
import style0 from "./TestPrice.vue?vue&type=style&index=0&id=64a0a626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a0a626",
  null
  
)

export default component.exports